import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Default from './Default';

export default class Reports extends Default {
  constructor() {
    super(false);
  }

  afterShow() {
    super.afterShow();
  }

  afterHide() {
    super.afterHide();
  }

  resize() {
    super.resize();
  }

  loop() {
    if (!this._isActive) return;
    super.loop();
  }
}

ControllerPage._addPage('reports', Reports);
